import React, { createContext, useState, useEffect, useContext } from "react";
import { SIGNIN_API } from "./APIHooks"; // Corrected typo

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser ] = useState(null);
  const [loading, setLoading] = useState(true);

  const signIn = async (email, password) => {
    try {
      const response = await fetch(SIGNIN_API, { // Use corrected constant
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: email, // Ensure correct key
          password: password,
        }),
      });

      const data = await response.json();

      if (data.success) { // Check for success
        const userData = {
          id: data.user.id, // Access user data correctly
          name: data.user.name,
          emailaddress: data.user.email,
          phonenumber: data.user.phone_number,
          role: data.user.role,
        };
        localStorage.setItem("userToken", JSON.stringify(userData));
        setUser (userData);
        return { success: true };
      } else {
        return { success: false, message: data.message };
      }
    } catch (error) {
      console.error(error);
      return {
        success: false,
        message: "An error occurred. Please try again.",
      };
    }
  };

  const signOut = () => {
    localStorage.removeItem("userToken");
    setUser (null);
  };

  const loadUser  = () => {
    const userToken = localStorage.getItem("userToken");
    if (userToken) {
      setUser (JSON.parse(userToken));
    }
    setLoading(false);
  };

  useEffect(() => {
    loadUser ();
  }, []);

  return (
    <AuthContext.Provider value={{ user, signIn, signOut, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
